(function () {
  'use strict';
  if (window.AnomAdAttribution) return;

  var COOKIE = 'shopify_utm';
  var LIFETIME = 30 * 86400;
  var fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'utm_placement', 'campaign_id', 'adset_id', 'ad_id', 'fbclid', 'gclid', 'gbraid', 'wbraid'];
  var aliases = { campaign_id: 'utm_campaign_id', adset_id: 'utm_adset_id', ad_id: 'utm_ad_id' };
  var owned = fields.concat(Object.values(aliases), ['anom_meta_fbp', 'anom_meta_fbc', 'anom_landing_page']);
  var lastSynced = '';
  var queue = Promise.resolve();
  var loadingPrivacy = false;

  function consent() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return privacy && typeof privacy.marketingAllowed === 'function' ? !!privacy.marketingAllowed() : null;
    } catch (_) { return null; }
  }

  function cookie(name) {
    try {
      var prefix = name + '=';
      var row = document.cookie.split(';').map(function (v) { return v.trim(); })
        .find(function (v) { return v.indexOf(prefix) === 0; });
      return row ? decodeURIComponent(row.slice(prefix.length)) : '';
    } catch (_) { return ''; }
  }

  function clean(value) {
    if (typeof value !== 'string') return '';
    value = value.trim();
    // Ignore unresolved ad macros and oversized/unexpected URL input.
    return value && value.length <= 256 && !/[\x00-\x1f\x7f]|\{\{|\}\}/.test(value) ? value : '';
  }

  function forget() {
    document.cookie = COOKIE + '=; path=/; max-age=0; SameSite=Lax; Secure';
  }

  function stored() {
    try {
      var result = JSON.parse(cookie(COOKIE) || '{}');
      if (!result || typeof result !== 'object' || Array.isArray(result)) return {};
      var age = Date.now() - result._capturedAt;
      if (!Number.isFinite(age) || age < 0 || age >= LIFETIME * 1000) return {};
      var values = { _capturedAt: result._capturedAt };
      fields.concat(['anom_meta_fbp', 'anom_meta_fbc']).forEach(function (key) {
        var value = clean(result[key]);
        if (value) values[key] = value;
      });
      // Never carry arbitrary query strings from the legacy cookie into orders.
      if (typeof result.anom_landing_page === 'string' && result.anom_landing_page.charAt(0) === '/') {
        values.anom_landing_page = result.anom_landing_page.split(/[?#]/)[0].slice(0, 256);
      }
      return values;
    } catch (_) { return {}; }
  }

  function attribution() {
    var params = new URLSearchParams(window.location.search);
    var incoming = {};
    fields.forEach(function (key) {
      var value = clean(params.get(key)) || (aliases[key] && clean(params.get(aliases[key])));
      if (value) incoming[key] = value;
    });
    var previous = stored();
    var hasIncoming = Object.keys(incoming).length > 0;
    var same = fields.every(function (key) { return (incoming[key] || '') === (previous[key] || ''); });
    var values = hasIncoming && !same ? Object.assign({ _capturedAt: Date.now() }, incoming) : previous;
    if (!values._capturedAt) return {};
    if (hasIncoming && !same) values.anom_landing_page = window.location.pathname.slice(0, 256);

    var fbp = clean(cookie('_fbp'));
    var fbc = clean(cookie('_fbc'));
    if (fbp) values.anom_meta_fbp = fbp;
    // Do not attach an old Meta click to a new Google or other campaign.
    if (values.fbclid) {
      if (fbc && fbc.endsWith('.' + values.fbclid)) values.anom_meta_fbc = fbc;
      else if (!values.anom_meta_fbc) values.anom_meta_fbc = 'fb.1.' + values._capturedAt + '.' + values.fbclid;
    } else { delete values.anom_meta_fbc; }
    return values;
  }

  function persist(values) {
    if (!values._capturedAt) { forget(); return; }
    var encoded = encodeURIComponent(JSON.stringify(values));
    // Cookie budget is conservative; preserve click/campaign IDs before descriptive text.
    ['utm_content', 'utm_term', 'utm_placement', 'anom_meta_fbp', 'anom_landing_page'].forEach(function (key) {
      if (encoded.length > 3600) { delete values[key]; encoded = encodeURIComponent(JSON.stringify(values)); }
    });
    if (encoded.length > 3600) { forget(); return; }
    var remaining = Math.max(0, Math.floor(LIFETIME - (Date.now() - values._capturedAt) / 1000));
    document.cookie = COOKIE + '=' + encoded + '; path=/; max-age=' + remaining + '; SameSite=Lax; Secure';
  }

  function sync() {
    queue = queue.then(async function () {
      var allowed = consent();
      if (allowed === null) return { status: 'privacy-unavailable' };
      var values = allowed ? attribution() : {};
      if (allowed) persist(values); else forget();
      var attributes = {};
      owned.forEach(function (key) { attributes[key] = values[key] || ''; });
      Object.keys(aliases).forEach(function (key) { attributes[aliases[key]] = values[key] || ''; });
      attributes.anom_marketing_consent = allowed ? 'yes' : 'no';
      var fingerprint = JSON.stringify(attributes);
      if (fingerprint === lastSynced) return { status: 'unchanged' };
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      if (!/^\/(?!\/)/.test(root)) root = '/';
      if (!root.endsWith('/')) root += '/';
      var response = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      });
      if (response.ok) lastSynced = fingerprint;
      return { status: response.ok ? 'synced' : 'retryable-error' };
    }).catch(function () { return { status: 'retryable-error' }; });
    return queue;
  }

  function refresh() {
    if (consent() === null && !loadingPrivacy && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      loadingPrivacy = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function () {
        loadingPrivacy = false;
        sync();
      });
    }
    sync();
  }

  window.AnomAdAttribution = { version: '20261021.1', sync: sync };
  document.addEventListener('visitorConsentCollected', refresh);
  window.addEventListener('pageshow', refresh);
  function start() {
    refresh();
    [500, 1500, 4000, 10000].forEach(function (delay) { setTimeout(refresh, delay); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
